module.exports = __webpack_public_path__ + "img/central-klaus-4.f0af3bfe.png";